import React from 'react';
import { SearchCard } from '../types';
import { BaseDesktopSearchCard } from '../Base';
import {
  Price,
  GrayUIText,
  Title,
  BottomContent,
  BlackUIText,
  UnitPriceText,
  DesktopReserveBarTimerWrapper,
  GrayPrice,
} from '../Base/styles';
import styled from 'styled-components';
import { theme } from '../../../../theme';
import { TruckIcon, MapMarkerIcon, BoxConditionIcon } from '../../../../assets';
import { ReserveBar } from '../../../reserveBar';
import { Timer } from '../../../timer';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[2].rem};
  margin: ${theme.spacings[2].rem};
  overflow: hidden;
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr;
`;

export const WineAuctionDesktopSearchCard: React.FC<
  SearchCard<'WineAuction'>
> = ({
  title,
  reserveStatus,
  reserveStatusMapping,
  enforceReserve,
  condition,
  location,
  isDelivery,
  grayPrice,
  data,
  type,
  timeLeft,
  ...props
}) => {
  return (
    <BaseDesktopSearchCard {...props}>
      <Content>
        <Title>{title}</Title>
        <DesktopReserveBarTimerWrapper>
          {reserveStatus && (
            <ReserveBar
              reserveStatus={reserveStatus}
              reserveStatusMapping={reserveStatusMapping}
            />
          )}
          <Timer format="long" closingTime={timeLeft} />
        </DesktopReserveBarTimerWrapper>
        <div>
          {grayPrice && <GrayPrice>{grayPrice}</GrayPrice>}
          <Container>
            <div>
              <Price>{data.perBottlePrice}</Price>
              <BlackUIText>
                <UnitPriceText>Per {data.unitPricing.unitName}</UnitPriceText>
              </BlackUIText>
            </div>
            <div>
              <Price>{data.secondaryPrice.price}</Price>
              <BlackUIText>
                <UnitPriceText>
                  Per {data.unitPricing.unitCollectiveNoun}
                </UnitPriceText>
              </BlackUIText>
            </div>
          </Container>
        </div>
        <BottomContent>
          <GrayUIText>
            <BoxConditionIcon
              width={16}
              fill={theme.colors.neutrals.solidGrays[3]}
            />
            {condition}
          </GrayUIText>
          <GrayUIText>
            {isDelivery ? (
              <>
                <TruckIcon
                  width={16}
                  fill={theme.colors.neutrals.solidGrays[3]}
                />
                Delivery
              </>
            ) : (
              <>
                <MapMarkerIcon
                  width={16}
                  fill={theme.colors.neutrals.solidGrays[3]}
                />
                {location}
              </>
            )}
          </GrayUIText>
        </BottomContent>
      </Content>
    </BaseDesktopSearchCard>
  );
};
